import $ from 'jquery';
import Swiper from 'swiper';
import 'swiper/css';

export default function ExhibitionSlider() {
    const $swiperContainer = $('.swiper-container');
    const numSlides = $swiperContainer.find('.swiper-slide').length;

    if (numSlides > 0) {
        new Swiper('.swiper-container', {
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: true,
            loopedSlides: numSlides,
            freeMode: false,
            grabCursor: true,
            threshold: 5,
        });
    }
}
